export default __webpack_public_path__ + "static/media/H0006.764cbd9c.png";